import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomRadioButtonComponent } from './custom-radio-button.component';
import { MaterialModule } from '../../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CustomRadioButtonComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  exports: [CustomRadioButtonComponent],
  providers: [],
})
export class CustomRadioButtonModule {}
